@if (label()) {
    <label class="form-label fs-6">{{ label() }}</label>
}
<div class="{{ styles() }}">
    @for (option of options(); track $index; let i = $index) {
        <div class="form-check m-1" [dir]="direction()">
            <input
                #radioButton
                class="form-check-input fw-bold"
                type="radio"
                [value]="option.value"
                [name]="controlName()"
                [id]="effectiveControlId() + '-' + i"
                [checked]="option.value === setDefaultValue()"
                (change)="inputChanges.emit(option.value)"
                style="cursor: pointer"
            />
            <label class="form-check-label fw-bold" [for]="effectiveControlId() + '-' + i"> {{ option.text }} </label>
        </div>
    }
</div>
